import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import Avatar from '@components/@core/Avatar';

const Header = () => (
    <div className="d-flex border-bottom desktop-flex">
        <div className="d-flex-5">
            <span className="dsl-m12">Company</span>
        </div>
        <div className="d-flex-5">
            <span className="dsl-m12">Status</span>
        </div>
        <div className="d-flex-4">
            <span className="dsl-m12">Action</span>
        </div>
    </div>
);

const Companies = ({ permission }) => {
    const { businesses } = permission;
    return (
        <div className="card-bottom">
            <p className="dsl-d12">Here is The list of companies you are associated with.</p>
            <p className="dsl-b18 bold">Companies I'm active in</p>
            <Header />
            {businesses.map((item) => {
                const { business, permission } = item;
                return (
                    <div className="d-flex ssm-column py-3" key={`hcm-${business.id}`}>
                        <div className="d-flex-5 d-h-start">
                            <Avatar type="logo" name={business.name} url={business.data?.profile?.avatar} isSponsored={true} />
                            <span className="dsl-b14 text-400 ms-3">{business.name}</span>
                        </div>
                        <div className="d-flex-5">
                            <label className="dsl-b14 d-sm-none w-30">Status</label>
                            <span className="dsl-b12 text-400">{permission === 'none' ? 'Na' : permission}</span>
                        </div>
                        <div className="d-flex-4">
                            <label className="dsl-b14 d-sm-none w-30">Action</label>
                            <span className="dsl-b14 text-400 ms-2 ssm-l-0">{moment(business.updated_at).format('MMM DD, YY')}</span>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

Companies.propTypes = {
    permission: PropTypes.shape({
        user_id: PropTypes.number,
        blogs: PropTypes.array,
        businesses: PropTypes.array,
        hcms: PropTypes.array,
        vrs: PropTypes.array,
    }),
};

Companies.defaultProps = {
    permission: {
        user_id: 0,
        blogs: [],
        businesses: [],
        hcms: [],
        vrs: [],
    },
};

export default Companies;
